import { KvSyncMqttSubscriber } from '@ahaslides-product/frontend-toolkit'
import mqttClient from './mqtt.client'

const kvSyncSubscriber = new KvSyncMqttSubscriber(mqttClient)
export default kvSyncSubscriber
